import { useMemo, useState } from "react";

export default function CountriesTab(props) {
  const {
    countries,
    unlockedCountries,
    gameCash,
    onUnlockCountry,
    money,
    number
  } = props;

  const [query, setQuery] = useState("");

  const filteredCountries = useMemo(function () {
    const q = query.trim().toLowerCase();
    if (!q) return countries;
    return countries.filter(function (country) {
      return `${country.name} ${country.code}`.toLowerCase().includes(q);
    });
  }, [countries, query]);

  const unlocked = filteredCountries.filter(function (country) {
    return unlockedCountries.includes(country.code);
  });

  const locked = filteredCountries.filter(function (country) {
    return !unlockedCountries.includes(country.code);
  });

  return (
    <div className="tabContent">
      <div className="sectionTitle">
        <div>
          <h2>Země</h2>
          <p>Odemčené státy určují, která letiště na mapě uvidíš a kam můžeš plánovat linky.</p>
        </div>
        <strong>{unlocked.length} / {filteredCountries.length}</strong>
      </div>

      <input
        className="countrySearch"
        value={query}
        onChange={function (event) { setQuery(event.target.value); }}
        placeholder="Hledat stát nebo kód"
      />

      <div className="countrySummary">
        <span><b>{unlocked.length}</b><em>odemčené státy</em></span>
        <span><b>{locked.length}</b><em>zamčené státy</em></span>
        <span><b>{money(gameCash)}</b><em>aktuální kapitál</em></span>
      </div>

      <details className="fold" open>
        <summary>Odemčené státy</summary>
        <div className="countryGrid">
          {unlocked.map(function (country) {
            return (
              <article key={country.code} className="countryCard unlocked">
                <div>
                  <strong>{country.name}</strong>
                  <span>{country.code}</span>
                </div>
                <div className="countryMeta">
                  <span><b>{number(country.airportCount)}</b><em>letišť</em></span>
                  <span><b>{number(country.largeCount)}</b><em>velká letiště</em></span>
                </div>
              </article>
            );
          })}
          {unlocked.length === 0 && <p className="emptyText">Filtru neodpovídá žádný odemčený stát.</p>}
        </div>
      </details>

      <details className="fold" open>
        <summary>Zamčené státy</summary>
        <div className="countryGrid">
          {locked.map(function (country) {
            const affordable = gameCash >= country.price;
            return (
              <article key={country.code} className="countryCard">
                <div>
                  <strong>{country.name}</strong>
                  <span>{country.code}</span>
                </div>
                <p>{number(country.airportCount)} letišť, z toho {number(country.largeCount)} velká.</p>
                <div className="countryMeta">
                  <span><b>{money(country.price)}</b><em>cena odemčení</em></span>
                </div>
                <button disabled={!affordable} onClick={function () { onUnlockCountry(country.code); }}>
                  {affordable ? "Odemknout stát" : "Málo peněz"}
                </button>
              </article>
            );
          })}
          {locked.length === 0 && <p className="emptyText">Filtru neodpovídá žádný zamčený stát.</p>}
        </div>
      </details>
    </div>
  );
}
